import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Tick: FC<IconProps> = ({ title, ...rest }) => (
  <Icon {...rest} title={title || 'Tick icon'}>
    <path
      fill="currentColor"
      d="M26.6 6.2c.4.3.5.9.2 1.4l-12 18a1 1 0 0 1-1.5.1l-8-8a1 1 0 1 1 1.4-1.4l7.1 7.1 11.4-17a1 1 0 0 1 1.4-.2Z"
    />
  </Icon>
);
